<!-- header -->
<header id="mainheader" style="background-color:{{background}}" >
  
  <div></div>
  <div class="saludo" >
    <div class="logo">
      <div class="logo" *ngIf="colegio.avatar!='';else elsebox" >
        <img src="{{avatar}}" routerLink="/dashboard" alt="">
      </div>
      <ng-template class="logo" #elsebox  >
        <img src="assets/img/logoColegia.png" routerLink="/dashboard" alt="">
      </ng-template>
    </div>

    <ng-container *ngIf="nombres && apellidos">
      <div *ngIf="genero=='masculino'; else elsebox"><p translate>dashboard.header.bienvenido <span> {{nombres | titlecase }} {{apellidos | titlecase }}</span></p></div>
      <ng-template #elsebox> <p translate>dashboard.header.bienvenida<span>{{nombres | titlecase }} {{apellidos | titlecase }}</span></p></ng-template>
    </ng-container>


  </div>
   <div class="herramientas">
    <a href="https://www.colegia.tv/login-sso.php" target="_blank">
      <!-- <a routerLink="/dashboard/appsint/www.colegia.tv\login-sso.php"> -->
      <img
        src="assets/img/tools/colegiatv.png"
        alt="Go to site"
        style="cursor: pointer"
      />
    </a>
    <a href="https://adaptiveinstructionadvisor.ai/home" target="_blank">
      <img
        src="assets/img/tools/enliten.png"
        alt="Go to site"
        style="cursor: pointer"
      />
    </a>
    <!-- <a href="https://events.colegia.org/portal/schedule" target="_blank">
      <img
        src="assets/img/tools/eventos.png"
        alt="Go to site"
        style="cursor: pointer"
      />
    </a> -->
    <a *ngIf="rol!='estudiante' && rol!=null"  (click)="irMagisterio()" >
      <img
        src="assets/img/tools/magisnet.jpg"
        alt="Go to site"
        style="cursor: pointer"
      />
    </a>
  </div>
</header>
<!-- /header -->


<div *ngIf="loading" class="fullscreen-spinner">
  <div class="spinner"></div>
</div>

